import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link } from 'react-router-dom';
import TablaComprobantesTrabajador from '../utils/TablaComprobantesTrabajador';

const RoleAccessLayer = () => {
    return (
        <>
            <TablaComprobantesTrabajador />
        </>
    );
};

export default RoleAccessLayer;